var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"required",attrs:{"dense":"","height":"20px","value":_vm.value,"required":"","validate-on-blur":""},on:{"input":value => _vm.$emit('input', value)}},'v-text-field',[_vm.$props, _vm.$attrs],false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }